export const SITE_METADATA = {
  title: `Mandala Booking`,
  author: 'Mandala Hotels',
  description: 'Mandala Booking',
  headerTitle: `Mandala Booking`,
  language: 'en-us',
  hotel: 'Mandala Hospitality',
  theme: 'system', // system, dark or light
  siteUrl: process.env.NEXT_PUBLIC_SITE_URL || 'https://backend-beta.mandalahotels.com.vn',
  apiUrl: process.env.NEXT_PUBLIC_CMS_URL || 'https://cms-uat.mandalahotels.com.vn',
  mediaHostUrl: process.env.NEXT_PUBLIC_CMS_URL || 'https://backend-beta.mandalahotels.com.vn',
  siteLogo: `${process.env.BASE_PATH || ''}/static/images/mandala-logo.png`,
  socialBanner: `${process.env.BASE_PATH || ''}/static/images/mandala-banner.png`,
  locale: 'en-US',
  stickyNav: true,
}
